
import React from "react";

import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import RTLDefault from "views/rtl/default";

import Roles from "views/admin/roles";
import Employees from "views/admin/employees";
import Organization from "views/admin/organization";
import Schools from "views/admin/schools";
import Parties from "views/admin/parties";
import JourneyPlans from "views/admin/journey-plans";

import Attendance from "views/admin/attendance";
import AttendanceDetail from "views/admin/attendance/detail";

import Visits from "views/admin/visits";
import VisitDetail from "views/admin/visits/detail";

import Expenses from "views/admin/expenses";

import TaDaClaims from "views/admin/ta-da";
import TaDaDetail from "views/admin/ta-da/detail";

import Collections from "views/admin/collections";
import CollectionDetail from "views/admin/collections/detail";

import Appraisals from "views/admin/appraisals";

import SampleTracking from "views/admin/sample-tracking";
import SampleTrackingDetail from "views/admin/sample-tracking/detail";

import Books from "views/admin/books";
import Reports from "views/admin/reports";

// Existing component path — do not change it.
import TourPrograms from "views/admin/tourPrograms";

import SignIn from "views/auth/SignIn";

import {
  MdHome,
  MdPerson,
  MdAssessment,
} from "react-icons/md";

// Admin-specific wrapper.
// Use a named component rather than an inline component
// inside the route configuration.
function AdminTourPrograms() {
  return <TourPrograms isAdmin={true} />;
}

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: MainDashboard,
    permission: "dashboard.view",
    showInSidebar: true,
  },

  {
    name: "Roles",
    layout: "/admin",
    path: "roles",
    icon: <MdPerson className="h-6 w-6" />,
    component: Roles,
    permission: "roles.manage",
    showInSidebar: true,
  },

  {
    name: "Employees",
    layout: "/admin",
    path: "employees",
    icon: <MdPerson className="h-6 w-6" />,
    component: Employees,
    permission: "employees.manage",
    showInSidebar: true,
  },

  {
    name: "Organization",
    layout: "/admin",
    path: "organization",
    icon: <MdPerson className="h-6 w-6" />,
    component: Organization,
    permission: "organization.manage",
    showInSidebar: true,
  },

  {
    name: "Schools",
    layout: "/admin",
    path: "schools",
    icon: <MdPerson className="h-6 w-6" />,
    component: Schools,
    permission: "schools.manage",
    showInSidebar: true,
  },

  {
    name: "Parties",
    layout: "/admin",
    path: "parties",
    icon: <MdPerson className="h-6 w-6" />,
    component: Parties,
    permission: "parties.manage",
    showInSidebar: true,
  },

  {
    name: "Journey Plans",
    layout: "/admin",
    path: "journey-plans",
    icon: <MdPerson className="h-6 w-6" />,
    component: JourneyPlans,
    permission: "journey.manage",
    showInSidebar: true,
  },

  // TOUR PROGRAMS
  {
    name: "Tour Programs",
    layout: "/admin",
    path: "tour-programs",
    icon: <MdPerson className="h-6 w-6" />,
    component: AdminTourPrograms,
    permission: "tour_programs.manage",
    showInSidebar: true,
  },

  {
    name: "Attendance",
    layout: "/admin",
    path: "attendance",
    icon: <MdPerson className="h-6 w-6" />,
    component: Attendance,
    permission: "attendance.view",
    showInSidebar: true,
  },

  {
    name: "Attendance Detail",
    layout: "/admin",
    path: "attendance/:id",
    component: AttendanceDetail,
    permission: "attendance.view",
    showInSidebar: false,
  },

  {
    name: "Visits",
    layout: "/admin",
    path: "visits",
    icon: <MdPerson className="h-6 w-6" />,
    component: Visits,
    permission: "visits.view",
    showInSidebar: true,
  },

  {
    name: "Visit Detail",
    layout: "/admin",
    path: "visits/:id",
    component: VisitDetail,
    permission: "visits.view",
    showInSidebar: false,
  },

  {
    name: "Expenses",
    layout: "/admin",
    path: "expenses",
    icon: <MdPerson className="h-6 w-6" />,
    component: Expenses,
    permission: "expenses.view",
    showInSidebar: true,
  },

  {
    name: "TA/DA",
    layout: "/admin",
    path: "ta-da",
    icon: <MdPerson className="h-6 w-6" />,
    component: TaDaClaims,
    permission: "ta_da.view",
    showInSidebar: true,
  },

  {
    name: "TA/DA Detail",
    layout: "/admin",
    path: "ta-da/:id",
    component: TaDaDetail,
    permission: "ta_da.view",
    showInSidebar: false,
  },

  {
    name: "Collections",
    layout: "/admin",
    path: "collections",
    icon: <MdPerson className="h-6 w-6" />,
    component: Collections,
    permission: "collections.view",
    showInSidebar: true,
  },

  {
    name: "Collection Detail",
    layout: "/admin",
    path: "collections/:id",
    component: CollectionDetail,
    permission: "collections.view",
    showInSidebar: false,
  },

  {
    name: "Appraisals",
    layout: "/admin",
    path: "appraisals",
    icon: <MdPerson className="h-6 w-6" />,
    component: Appraisals,
    permission: "appraisals.view",
    showInSidebar: true,
  },

  {
    name: "Sample Tracking",
    layout: "/admin",
    path: "sample-tracking",
    icon: <MdPerson className="h-6 w-6" />,
    component: SampleTracking,
    permission: "sample_tracking.view",
    showInSidebar: true,
  },

  {
    name: "Sample Tracking Detail",
    layout: "/admin",
    path: "sample-tracking/:id",
    component: SampleTrackingDetail,
    permission: "sample_tracking.view",
    showInSidebar: false,
  },

  {
    name: "Books",
    layout: "/admin",
    path: "books",
    icon: <MdPerson className="h-6 w-6" />,
    component: Books,
    permission: "books.view",
    showInSidebar: true,
  },

  {
    name: "Reports & Statements",
    layout: "/admin",
    path: "reports",
    icon: <MdAssessment className="h-6 w-6" />,
    component: Reports,
    permission: "reports.view",
    showInSidebar: true,
  },

  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    component: Profile,
    showInSidebar: false,
  },

  {
    name: "Data Tables",
    layout: "/admin",
    path: "data-tables",
    component: DataTables,
    showInSidebar: false,
  },

  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    component: SignIn,
    showInSidebar: false,
  },

  {
    name: "RTL",
    layout: "/rtl",
    path: "rtl",
    component: RTLDefault,
    showInSidebar: false,
  },
];

export default routes;
